import React, { useState, useEffect, useRef } from 'react'
import real_l from "../real_logo.png";
import { Link } from "react-router-dom"
import Axios from 'axios'
import { Host } from '../App';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import "./BOM_pivot.css";

function BOM_pivot() {
  var User = JSON.parse(window.localStorage.getItem("Name"));
  const nowDate = new Date();
  const formattedDate = nowDate.toLocaleDateString();
  const formattedTime = nowDate.toLocaleTimeString();

  const [Date1, setDate1] = useState(new Date());
  const [Postartdate, setPoStartdate] = useState(Date1.toISOString().slice(0, 10));
  const [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  const [isLoading, setIsLoading] = useState(false);

  var token = (window.localStorage.getItem("acessToken"));
  var [section, setsection] = useState("Supplies");
  const [Item_No, setItem_No] = useState("");

  const [showPart, setShowPart] = useState(false);

  const [bom, setBOM] = useState([{
    "Description": " ",
    "QTY": " ",
    "Receiving Date": "",
  }]);

  // ✅ Hover tooltip state (renders outside the scroll container)
  const [hoverTip, setHoverTip] = useState({
    open: false,
    x: 0,
    y: 0,
    title: "",
    body: ""
  });

  const closeHoverTip = () => setHoverTip((p) => ({ ...p, open: false }));

  const openHoverTip = (e, title, body) => {
    // position tooltip near the hovered item
    const rect = e.currentTarget.getBoundingClientRect();
    const x = rect.left + 10;
    const y = rect.bottom + 10;

    setHoverTip({
      open: true,
      x,
      y,
      title: title || "Parts",
      body: body ? String(body) : "No parts found"
    });
  };

  const handleSelectChange = (event) => {
    const selectedOption = event.target.value;
    const today = new Date();
    let startDate, endDate;

    if (selectedOption === 'lastWeek') {
      startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
      endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    } else if (selectedOption === 'thisWeek') {
      startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
      endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (6 - today.getDay()));
    } else if (selectedOption === 'lastMonth') {
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
    } else if (selectedOption === 'thisMonth') {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (selectedOption === 'nextWeek') {
      startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (7 - today.getDay()));
      endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (13 - today.getDay()));
    } else if (selectedOption === 'nextMonth') {
      startDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);
    } else if (selectedOption === 'currentQuarter') {
      const currentMonth = today.getMonth();
      const currentQuarter = Math.floor(currentMonth / 3) + 1;
      const currentQuarterStartMonth = (currentQuarter - 1) * 3;
      const currentQuarterEndMonth = currentQuarterStartMonth + 2;
      startDate = new Date(today.getFullYear(), currentQuarterStartMonth, 1);
      endDate = new Date(today.getFullYear(), currentQuarterEndMonth + 1, 0);
    } else if (selectedOption === 'nextQuarter') {
      const currentMonth = today.getMonth();
      const currentQuarter = Math.floor(currentMonth / 3) + 1;
      const nextQuarterStartMonth = (currentQuarter * 3) % 12;
      const nextQuarterEndMonth = nextQuarterStartMonth + 2;
      const nextQuarterYear = nextQuarterStartMonth === 0 ? today.getFullYear() + 1 : today.getFullYear();
      startDate = new Date(nextQuarterYear, nextQuarterStartMonth, 1);
      endDate = new Date(nextQuarterYear, nextQuarterEndMonth + 1, 0);
    } else if (selectedOption === 'nextDay') {
      startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1).toISOString().split('T')[0];
      endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1).toISOString().split('T')[0];
    }

    setPoStartdate(startDate);
    setPoEnddate(endDate);
  };

  const queryParams = {
    start_date: Postartdate,
    end_date: Poenddate,
    token: token,
    Item_No: Item_No
  };

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      Axios.get(`https://` + Host + `/BOM/pivot`, { params: queryParams }).then((data) => {
        if (data.data === "Error") {
          setIsLoading(false);
        } else {
          if (data.data.length > 0) {
            setBOM(data.data);
          } else if (data.data.length <= 1) {
            window.alert("No Data Received!")
          }
        }
        setIsLoading(false);
      }, 2000);

      setTimeout(() => setIsLoading(false), 3000);
    });
  }, [section, Poenddate, Postartdate, token, Item_No]);

  const toggleparts = () => {
    setShowPart(!showPart);
    // close tooltip when toggling
    closeHoverTip();
  }

  const downloadCSV = () => {
    const filename = "BOM";
    const csv = XLSX.utils.sheet_to_csv(XLSX.utils.json_to_sheet(bom));
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    FileSaver.saveAs(blob, filename);
  };

  const handlePrint = () => {
    const table = document.querySelector('#alldata');
    const printWindow = window.open("", "", "height=600,width=800");
    const img = document.createElement('img');
    img.src = real_l;

    printWindow.document.write(`
      <html>
        <head>
          <title></title>
          <style>
          h1 { display:inline-block; vertical-align:middle; margin:0; text-align:center; width:100%; font-family:Arial,sans-serif; }
          img { display:inline-block; height:50px; margin-right:10px; }
          table { border:1px solid black; border-collapse:collapse; width:100%; font-family:Arial,sans-serif; }
          th, td { border:1px solid black; padding:5px; }
          tr:nth-child(even) { background-color:#f2f2f2; }
          .bottom-right { position:relative; bottom:10px; right:10px; font-family:Arial,sans-serif; }
          table tr:last-child td { font-weight:bold; background-color:lightgrey; }
          </style>
        </head>
        <body>
          <h1>${img.outerHTML}</h1>
          <table class="table table-striped">${(table.innerHTML)}</table>
          <p class="bottom-right">Printed By: ${User}</p>
          <p class="bottom-right">Date Created: ${formattedDate + '  ' + formattedTime}</p>
        </body>
      </html>`
    );
    printWindow.document.close();
    printWindow.focus();
  };

  return (
    <div className="bompPage" onScroll={closeHoverTip}>
      <div className="bompCard">
        <div className="bompHeader">
          <div>
            <div className="bompTitle">BOM PIVOT</div>
          </div>

          <div className="bompHeaderActions">
            <Link to="/BOM">
              <button className="btn btn-primary bompBtn">Back</button>
            </Link>
            <button className="btn btn-success bompBtn" onClick={toggleparts}>
              {showPart ? "Hide Parts" : "Show Parts"}
            </button>
            <button className="btn btn-secondary bompBtn" onClick={downloadCSV}>
              Download CSV
            </button>
            <button className="btn btn-primary bompBtn" onClick={handlePrint}>
              Print Table
            </button>
          </div>
        </div>

        <div className="bompFilters">
          <div className="bompFilterBlock">
            <div className="bompLabelRow">
              <label>Choose ETA</label>
              <span className="bompHint">Quick ranges available</span>
            </div>

            <div className="bompDateRow">
              <div className="bompTooltipWrap">
                <input
                  type='date'
                  className="form-control form-rounded"
                  placeholder='ETA'
                  defaultValue={Postartdate}
                  onChange={(e) => setPoStartdate(e.target.value)}
                />
                <span className="bompTooltip">Filter by ETA range</span>
              </div>

              <input
                type='date'
                className="form-control form-rounded"
                defaultValue={Date1.toISOString().slice(0, 10)}
                onChange={(e) => setPoEnddate(e.target.value)}
              />

              {/* ✅ keeping your select exactly */}
              <div className="ROW">
                <select className="form-control form-rounded" onChange={handleSelectChange}>
                  <option value="">Select</option>
                  <option value="lastWeek">Last Week</option>
                  <option value="thisWeek">This Week</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="thisMonth">This Month</option>
                  <option value="nextWeek">Next Week</option>
                  <option value="nextMonth">Next Month</option>
                  <option value="currentQuarter">Current Quarter</option>
                  <option value="nextQuarter">Next Quarter</option>
                  <option value="nextDay">Next Day</option>
                </select>
              </div>
            </div>
          </div>

          <div className="bompFilterBlock">
            <label>Item No</label>
            <input
              type='text'
              className="form-control form-rounded"
              placeholder='Item No'
              list="ItemNo"
              onChange={(e) => setItem_No(e.target.value)}
            />
            <datalist id="ItemNo">
              <option></option>
              {bom.map((x, idx) => <option key={idx}>{x.Item_No}</option>)}
            </datalist>
          </div>
        </div>

        <div className="bompTableWrap">
          <table className="table table-light table-bordered bompTable" id='alldata'>
            <thead>
              <tr>
                <th className="bompStickyHead bompStickyCol">ITEM NO</th>
                <th className="bompStickyHead">QTY REQUIRED</th>
                <th className="bompStickyHead">UNIT</th>
              </tr>
            </thead>

            <tbody>
              {bom.map((val, index) => (
                <tr key={index}>
                  <td className="bompStickyCol">
                    <a
                      href="#"
                      className="bompItemLink"
                      style={{ textDecoration: "none" }}
                      onClick={(e) => e.preventDefault()}
                      onMouseEnter={(e) => {
                        if (!showPart) return;
                        openHoverTip(e, "Parts", val.Part_Nos);
                      }}
                      onMouseMove={(e) => {
                        if (!showPart) return;
                        // keep tooltip following a bit (optional but nice)
                        setHoverTip((p) => p.open ? { ...p, x: e.clientX + 12, y: e.clientY + 14 } : p);
                      }}
                      onMouseLeave={() => closeHoverTip()}
                    >
                      {val.Item_No}
                    </a>
                  </td>

                  <td>{val.Total_Qty_Required}</td>
                  <td>{val.Purchase_Unit}</td>
                </tr>
              ))}

              <tr className="bompTotalRow">
                <td className="bompStickyCol"><b>Total</b></td>
                <td><b>{bom.reduce((acc, val) => acc + (val.Total_Qty_Required || 0), 0).toFixed(2)}</b></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* ✅ Tooltip rendered OUTSIDE overflow container so it’s always visible */}
        {hoverTip.open ? (
          <div
            className="bompHoverTip"
            style={{ left: hoverTip.x, top: hoverTip.y }}
          >
            <div className="bompHoverTipTitle">{hoverTip.title}</div>
            <div className="bompHoverTipBody">{hoverTip.body}</div>
          </div>
        ) : null}

        {isLoading ? (
          <div className='bompOverlay'>
            <div className="bompLoadingBox">
              <div className="bompDots">
                <div className="bompDot"></div>
                <div className="bompDot"></div>
                <div className="bompDot"></div>
              </div>
              <p className='bompLoadingText'>Loading</p>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default BOM_pivot;
